import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { ToggleType } from './toggle-types.enum';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'ac-chart-table-toggle',
	templateUrl: './chart-table-toggle.component.html',
	styleUrls: ['./chart-table-toggle.component.scss']
})
export class ChartTableToggleComponent implements OnInit {
	@Input() public initialType: ToggleType;
	@Input() public showIconView: boolean = false;
	@Output() public newToggleStatus = new EventEmitter<ToggleType>();
	public toggleType = ToggleType;

	public toggleStatus: ToggleType;

	public ngOnInit(): void {
		this.toggleStatus = this.initialType;
	}

	public toggle(newType: ToggleType): void {
		this.toggleStatus = newType;
		this.newToggleStatus.emit(newType);
	}
}
